import { ImageCheck, LinkWrapper } from "Explore/Components";
import { ImageCheckType, ImageType } from "Explore/Config/ImageType";
import styles from "./InstitutionCard.module.scss";
import { IconPack } from "Explore/Config/Icons";
import { numberRegex } from "Explore/Utils/numberRegex";
import classNames from "classnames";
import { Grid } from "@mui/material";
import { state_select } from "Explore/Config/FilterData";
import FavoriteButton from "../FavoriteButton";
import useDeviceCheck from "Hooks/useDeviceCheck";
import InstitutionCardBasicInfo from "./BasicInfo";

const InstitutionCard = ({ data, className, simpleMode, hideActions }) => {
  const { isMobile } = useDeviceCheck();
  const statistics = [
    {
      icon: IconPack.publications,
      value: data.publication_count || data.total_publication,
      title: "Publications",
    },
    {
      icon: IconPack.h_index,
      value: data.h_index || data.total_h_index,
      title: "H-index",
    },
    {
      icon: IconPack.citation,
      value: data.citation_count || data.total_citation,
      title: "Citations",
    },
    {
      icon: IconPack.unit_faculty_members,
      value: data.total_faculties,
      title: "Indexed faculty members",
    },
    {
      icon: IconPack.seniority,
      value: data.average_seniority,
      title: "Average academic age",
    },
  ].filter((e) => !!e.value);
  return (
    <div className={classNames(styles["institution-card"], className)}>
      <div className={styles["institution-card__top"]}>
        <LinkWrapper
          link={`/explore/institution/${data.explore_slug || data.id}`}
          component={
            <ImageCheck
              url={data.photo_url}
              className={styles["avatar"]}
              alt={"avatar"}
              altImg={`https://media.academic.online/institutions_images/${data.id}/${ImageType.SEAL}.png`}
              type={ImageCheckType.CUSTOM}
            />
          }
        />
        <div className={styles["name--wrapper"]}>
          <LinkWrapper
            link={`/explore/institution/${data.explore_slug || data.id}`}
            component={
              <div className={classNames(styles["name"], styles["link"])}>
                <p>{data.name}</p>
              </div>
            }
          />

          {!hideActions && (
            <div className={styles["entity-actions"]}>
              <FavoriteButton
                isFavorited={data.is_favorited}
                itemId={data.id}
                itemType="institution"
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles["institution-card__body"]}>
        <div className={styles["institution-card__body__left"]}>
          <div className={styles["institution-card__body--item"]}>
            <p className={styles["institution-card__body--item--title"]}>
              Location
            </p>
            <p className={styles["institution-card__body--item--value"]}>
              {data?.city},{" "}
              {state_select.find((e) => e.value === data.state)?.label}
            </p>
          </div>
          <div className={styles["institution-card__body--item"]}>
            <p className={styles["institution-card__body--item--title"]}>
              Type
            </p>
            <p className={styles["institution-card__body--item--value"]}>
              {data?.control}
            </p>
          </div>
        </div>

        {/* {statistics.length > 0 && (
          <div className={styles["institution-card__body__right"]}>
            <Grid container className={styles["statistics"]} spacing="24px">
              {statistics.map((e, i) => (
                <Grid
                  item
                  xs={(!isMobile && statistics.length) > 4 ? 4 : 6}
                  key={i}
                >
                  <div className={styles["statistic"]}>
                    {e.icon}
                    <div className={styles["institution-card__body--item"]}>
                      <p
                        className={
                          styles["institution-card__body--item--title"]
                        }
                      >
                        {e.title}
                      </p>
                      <p
                        className={
                          styles["institution-card__body--item--value"]
                        }
                      >
                        {numberRegex(e.value)}
                      </p>
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
          </div>
        )} */}
      </div>
      <div className={styles["institution-card__bottom"]}>
        {data.keywords && data.keywords.length > 0 && (
          <div className={styles["keywords"]}>
            <span>Noticable Interests: </span>
            {data.keywords.map((item, index) => (
              <div className={styles["keywords--item"]} key={index}>
                {item.rank && <b>#{item.rank}&nbsp;</b>}
                {item.value}
              </div>
            ))}
          </div>
        )}

        <div className={styles["bio-institution"]}>{data.bio}</div>
      </div>
      {!simpleMode && <InstitutionCardBasicInfo data={data} />}
    </div>
  );
};

export default InstitutionCard;
